import React from 'react';
import { SvgIcon } from '@material-ui/core';
const SmartPhone = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 24 24", fill: "none" }),
    React.createElement("path", { d: "M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z", stroke: "#6A3EEA", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }),
    React.createElement("path", { d: "M12 18H12.01", stroke: "#6A3EEA", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })));
export default SmartPhone;
